import type { TaskEither } from 'fp-ts/lib/TaskEither';
import { fetchTE } from 'utils/request';

export const updateUserOrgMemberTE = <E = CF.API.ApiError>(
  { orgId, userId, memberRoleId }: { orgId: string; userId: string; memberRoleId: string },
  onRejected?: (e: CF.API.ApiError) => E,
): TaskEither<E, CF.API.BaseResponse> =>
  fetchTE<CF.API.BaseResponse, E>(
    {
      path: `/api/_api/v2/organizations/${orgId}/members`,
      method: 'PATCH',
      body: {
        action: 'overwrite',
        organization_members: [
          {
            id: userId,
            role_id: memberRoleId,
          },
        ],
      },
    },
    onRejected,
  );
